// import React from "react";
// import {
//   Box,
//   Container,
//   Grid,
//   IconButton,
//   Link,
//   List,
//   ListItem,
//   makeStyles,
//   Typography,
// } from "@material-ui/core";
// import {
//   FaTwitter,
//   FaTelegramPlane,
//   FaWhatsapp,
//   FaInstagram,
// } from "react-icons/fa";

// const useStyles = makeStyles((theme) => ({
//   footerSection: {
//     position: "relative",
//     padding: "50px 0px 0",
//     zIndex: "2",
//     overflow: " hidden",
//     background: "rgba(255, 255, 255, 0.02)",
//     background: "url(/images/footer_banner.png) no-repeat center/cover",
//     color: "#fff",
//     padding: "20px 0 0",
//     backgroundRepeat: "no-repeat",
//     "& p": {
//       color: "rgba(255, 255, 255, 0.87)",
//     },
//     "& .copy": {
//       borderTop: "1px solid #d0d0d017",
//       padding: "10px 0",
//       textAlign: "center",
//       fontWeight: 300,
//       fontSize: "12px",
//       "& p": {
//         color: "rgba(255, 255, 255, 0.87)",
//         fontWeight: "300",
//         fontSize: "13px",
//       },
//     },
//     "& svg": {
//       color: "#f53756 !important",
//       fontSize: "27px !important",
//       cursor: "pointer",
//     },
//     "& h6": {
//       [theme.breakpoints.down("sm")]: {
//         marginTop: "30px",
//       },
//       [theme.breakpoints.down("xs")]: {
//         marginTop: "10px",
//       },
//     },
//     "& .MuiListItem-gutters":{
//       paddingLeft:"0px",
//     },
//     "& a": {
//       fontSize: "14px !important",
//     },
//   },
//   footerContentBox: {
//     maxWidth: "260px",
//     [theme.breakpoints.down("xs")]: {
//       maxWidth: "100%",
//     },
//   },
//   iconbtn: {
//     display: "flex",
//     alignItems: "center",
//     "& .MuiIconButton-root": {
//       background: "transparent",
//       marginRight: "15px",
//       padding: "0px",
//       [theme.breakpoints.down("xs")]: {
//         marginBottom: "10px",
//       },
//     },
//   },
// }));

// const Footer = () => {
//   const classes = useStyles();

//   return (
//     <Box className={classes.footerSection}>
//       <Container maxWidth="lg">
//         <Grid container spacing={3}>
//           <Grid item xs={12} sm={12} md={4}>
//             <Box className={classes.footerContentBox}>
//               <Box mb={2}>
//                 {" "}
//                 <Link href="/">
//                   <img
//                     src="/images/logo.svg"
//                     alt=""
//                     style={{ width: "152px" }}
//                   />{" "}
//                   <br />
//                 </Link>
//               </Box>
//               <Typography
//                 variant="body2"
//                 style={{ color: "#F53756", maxWidth: "201px",fontWeight:"700" }}
//               >
//                 The NFT Marketplace for Fine Wines
//               </Typography>
//             </Box>
//           </Grid>
//           <Grid item xs={6} sm={3} md={3}>
//             <Typography
//               variant="body2"
//               style={{ color: "#F53756", fontWeight: "700",fontSize:"16px" }}
//               color="primary"
//             >
//               Platform
//             </Typography>
//             <List>
//               <ListItem href="/brands" component={Link}>
//                 Brands
//               </ListItem>

//               <ListItem href="/marketplace" component={Link}>
//                 Marketplace
//               </ListItem>

//               <ListItem href="/faq" component={Link}>
//                 FAQ
//               </ListItem>
//             </List>
//           </Grid>

//           <Grid item xs={6} sm={3} md={3}>
//             <Typography
//               variant="body2"
//               style={{ color: "#F53756", fontWeight: "700",fontSize:"16px" }}
//               color="primary"
//             >
//               Contact Us
//             </Typography>
//             <List>
//               <ListItem>
//                 <Link href="mailto:Vintage@mailinator.com">
//                   Vintage@mailinator.com
//                 </Link>
//               </ListItem>

//               <ListItem style={{ cursor: "pointer" }}>
//                 <Link>9109-9806432790</Link>
//               </ListItem>
//             </List>
//           </Grid>
//           <Grid item xs={6} sm={3} md={2}>
//             <Typography
//               variant="body2"
//               style={{ color: "#F53756", fontWeight: "700",fontSize:"16px" }}
//               color="primary"
//             >
//               Follow Us:
//             </Typography>

//             <Box className="iconbtn" mt={2}>
//               <IconButton target="_blank" href="https://www.whatsapp.com/" style={{padding:"0px"}}>
//                 <Link>
//                   <FaWhatsapp />
//                 </Link>
//               </IconButton>
//               <IconButton style={{padding:"0px",marginLeft:"16px"}}>
//                 <Link target="_blank" href="https://twitter.com">
//                   <FaTwitter />
//                 </Link>
//               </IconButton>
//               <IconButton style={{padding:"0px",marginLeft:"16px"}}>
//                 <Link target="_blank" href="https://telegram.org/">
//                   <FaTelegramPlane />
//                 </Link>
//               </IconButton>
//               <IconButton style={{padding:"0px",marginLeft:"16px"}}>
//                 <Link target="_blank" href="https://intagram.com/">
//                   <FaInstagram />
//                 </Link>
//               </IconButton>
//             </Box>
//           </Grid>
//         </Grid>
//       </Container>
//       <Box className="copy" mt={1}>
//         <Container >
//           <Box
//             alignItems="center"
//             position="relative"
//             flexWrap="wrap"
//             display="flex"
//             justifyContent="space-between"
//           >
//             <Typography variant="body2">© 2023 Vintage</Typography>
//             <Box className="displayStart">
//               <List className="displayStart">
//                 <ListItem
//                   href="/about-us"
//                   target="_blank"
//                   component={Link}
//                   style={{ whiteSpace: "pre" }}
//                 >
//                   About Us
//                 </ListItem>
//                 <ListItem
//                   href="/privacy-policy"
//                   target="_blank"
//                   component={Link}
//                   style={{ whiteSpace: "pre" }}
//                 >
//                   Privacy Policy
//                 </ListItem>
//                 <ListItem
//                   href="/terms-conditions"
//                   target="_blank"
//                   component={Link}
//                   style={{ whiteSpace: "pre" }}
//                 >
//                   Terms & Conditions
//                 </ListItem>
//               </List>
//             </Box>
//           </Box>
//         </Container>
//       </Box>
//     </Box>
//   );
// };

// export default Footer;









"use client";

import React, { useState } from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  IconButton,
  useTheme,
  useMediaQuery,
  Collapse,
  List,
  ListItem,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

export default function Footer() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const [servicesOpen, setServicesOpen] = useState(false);

  const handleServicesToggle = () => {
    setServicesOpen(!servicesOpen);
  };
  
  return (
      <Box
        component="footer"
        sx={{
          backgroundColor: "white",
          color: "black",
          py: { xs: 4, sm: 5, md: 6, lg: 6, xl: 6 },
          px: { xs: 2, sm: 3, md: 4, lg: 8, xl: 8 },
        }}
      >
      <Container 
        maxWidth={false}
        sx={{
          maxWidth: { xs: "100%", sm: 1200, md: 1400, lg: 1500, xl: 1500 },
          px: { xs: 1, sm: 2, md: 4, lg: 6, xl: 6 },
        }}
      >
        {/* Logo / Brand */}
        <Typography
          variant="h1"
          sx={{
            fontFamily: 'Questrial, sans-serif',
            fontStyle: 'normal',
            fontSize: { 
              xs: "6rem", 
              sm: "7rem", 
              md: "10rem", 
              lg: "18rem", 
              xl: "22rem" 
            },
            fontWeight: 400,
            textAlign: "center",
            mb: { xs: 4, sm: 5, md: 6, lg: 6, xl: 6 },
            lineHeight: 1.3,
            wordBreak: "break-word",
            
          }}
        >
          Tokenate
        </Typography>

        <Grid container justifyContent="start">
          {/* Left - Navigation */}
          <Grid item   sx={{ width: { xs: "20%", sm: "20%", md: "10%", lg: "10%", xl: "10%" } }}>
            <Box
              sx={{
                fontFamily: "'questrial', sans-serif !important",
                display: "flex",
                flexDirection: "column",
                gap: { xs: 0.5, sm: 0.8, md: 0.8, lg: 0.8, xl: 0.8 },
                fontSize: { xs: "0.85rem", sm: "0.9rem", md: "0.9rem", lg: "0.9rem", xl: "0.9rem" },
                alignItems: { xs: "center", sm: "center", md: "flex-start", lg: "flex-start", xl: "flex-start" },
                textAlign: { xs: "center", sm: "center", md: "left", lg: "left", xl: "left" },
                width: { xs: "80%", sm: "80%", md: "50%", lg: "50%", xl: "50%" },
              }}
            >
              <Link
                href="/"
                underline="none"
                sx={{ 
                  color: "#5b6f92", 
                  fontSize: { xs: "0.85rem", sm: "0.9rem", md: "0.9rem", lg: "0.9rem", xl: "0.9rem" },
                  "&:hover": { color: "#4a5d7a" },
                }}
              >
                Home
              </Link>
              <Link
                href="/Topcreater#about-us"
                underline="none"
                sx={{ 
                  color: "black", 
                  fontSize: { xs: "0.85rem", sm: "0.9rem", md: "0.9rem", lg: "0.9rem", xl: "0.9rem" },
                  "&:hover": { color: "#333" },
                }}
              >
                About Us
              </Link>
              <Link
                href="/solutions"
                underline="none"
                sx={{ 
                  color: "black", 
                  fontSize: { xs: "0.85rem", sm: "0.9rem", md: "0.9rem", lg: "0.9rem", xl: "0.9rem" },
                  "&:hover": { color: "#333" },
                }}
              >
                Solutions
              </Link>

              {/* Services with dropdown */}
              <Box sx={{ 
                display: "flex", 
                flexDirection: "column",
                alignItems: { xs: "center", sm: "center", md: "flex-start", lg: "flex-start", xl: "flex-start" },
              }}>
                <Box sx={{ 
                  display: "flex", 
                  alignItems: "center",
                  justifyContent: { xs: "center", sm: "center", md: "flex-start", lg: "flex-start", xl: "flex-start" },
                }}>
                  <Link
                    href="/services"
                    underline="none"
                    sx={{ 
                      color: "black", 
                      fontSize: { xs: "0.85rem", sm: "0.9rem", md: "0.9rem", lg: "0.9rem", xl: "0.9rem" }, 
                      mr: 0.5,
                      "&:hover": { color: "#333" },
                    }}
                  >
                    Services
                  </Link>
                  {/* <IconButton
                    size="small"
                    onClick={handleServicesToggle}
                    sx={{
                      p: 0,
                      color: "black",
                      "& .MuiSvgIcon-root": {
                        fontSize: { xs: "1rem", sm: "1.2rem", md: "1.2rem", lg: "1.2rem", xl: "1.2rem" },
                      },
                    }}
                  >
                    {servicesOpen ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
                  </IconButton> */}
                </Box>
                
                {/* Services Dropdown */}
                {/* <Collapse in={servicesOpen} timeout="auto" unmountOnExit>
                  <List sx={{ 
                    pl: { xs: 0, md: 2 }, 
                    pt: 1,
                    "& .MuiListItem-root": {
                      py: 0.5,
                      px: 0,
                      minHeight: "auto",
                    }
                  }}>
                    <ListItem>
                      <Link
                        href="/services/tokenization-lifecycle"
                        underline="none"
                        sx={{ 
                          color: "black", 
                          fontSize: { xs: "0.7rem", sm: "0.75rem" },
                          "&:hover": { color: "#333" },
                        }}
                      >
                        Tokenization Lifecycle Management
                      </Link>
                    </ListItem>
                    <ListItem>
                      <Link
                        href="/services/security-compliance"
                        underline="none"
                        sx={{ 
                          color: "black", 
                          fontSize: { xs: "0.7rem", sm: "0.75rem" },
                          "&:hover": { color: "#333" },
                        }}
                      >
                        Security, Compliance, and Audit
                      </Link>
                    </ListItem>
                    <ListItem>
                      <Link
                        href="/services/interoperability"
                        underline="none"
                        sx={{ 
                          color: "black", 
                          fontSize: { xs: "0.7rem", sm: "0.75rem" },
                          "&:hover": { color: "#333" },
                        }}
                      >
                        Interoperability, Analytics, and Reporting
                      </Link>
                    </ListItem>
                  </List>
                </Collapse> */}
              </Box>

              <Link
                href="/contact"
                underline="none"
                sx={{ 
                  color: "black", 
                  fontSize: { xs: "0.85rem", sm: "0.9rem", md: "0.9rem", lg: "0.9rem", xl: "0.9rem" },
                  "&:hover": { color: "#333" },
                }}
              >
                Contact
              </Link>
            </Box>
          </Grid>

          {/* Right - Address */}
          <Grid item xs={12} md={5}>
            <Box
              sx={{
                fontFamily: "'questrial', sans-serif !important",
                display: "flex",
                flexDirection: "column",
                gap: { xs: 0.3, sm: 0.4, md: 0.4, lg: 0.4, xl: 0.4 },
                fontSize: { xs: "0.85rem", sm: "0.9rem", md: "0.9rem", lg: "0.9rem", xl: "0.9rem" },
                alignItems: { xs: "center", sm: "center", md: "flex-start", lg: "flex-start", xl: "flex-start" },
                textAlign: { xs: "center", sm: "center", md: "left", lg: "left", xl: "left" },
                mt: { xs: 3, sm: 3, md: 0, lg: 0, xl: 0 },
               
              }}
            >
              <Typography sx={{ 
                fontFamily: "'questrial', sans-serif !important",
                fontSize: { xs: "0.85rem", sm: "0.9rem", md: "0.9rem", lg: "0.9rem", xl: "0.9rem" },
                fontWeight: { xs: 500, md: 400 },
              }}>TECHT Labs LTD</Typography>
              <Typography sx={{ 
                fontFamily: "'questrial', sans-serif !important",
                fontSize: { xs: "0.85rem", sm: "0.9rem", md: "0.9rem", lg: "0.9rem", xl: "0.9rem" },
              }}>
                Level 39, 1 Canada Square
              </Typography>
              <Typography sx={{ 
                fontFamily: "'questrial', sans-serif !important",
                fontSize: { xs: "0.85rem", sm: "0.9rem", md: "0.9rem", lg: "0.9rem", xl: "0.9rem" },
              }}>Canary Wharf</Typography>
              <Typography sx={{ 
                fontSize: { xs: "0.85rem", sm: "0.9rem", md: "0.9rem", lg: "0.9rem", xl: "0.9rem" },
              }}>
                160 Robinson Road #14-04
              </Typography>
              <Typography sx={{ 
                fontFamily: "'questrial', sans-serif !important",
                fontSize: { xs: "0.85rem", sm: "0.9rem", md: "0.9rem", lg: "0.9rem", xl: "0.9rem" },
              }}>
                Singapore Business Federation Center
              </Typography>
            </Box>
          </Grid>
        </Grid>

        {/* Bottom - Copyright and Policy Links */}
        <Box sx={{ 
          fontFamily: "'questrial', sans-serif !important",
          display: "flex",
          flexDirection: { xs: "column", sm: "column", md: "row", lg: "row", xl: "row" },
          justifyContent: "space-between",
          alignItems: { xs: "center", sm: "center", md: "center", lg: "center", xl: "center" },
          mt: { xs: 4, sm: 5, md: 6, lg: 6, xl: 6 },
          gap: { xs: 2, sm: 2, md: 0, lg: 0, xl: 0 },
        }}>
          {/* Policy Links */}
          <Box sx={{ 
            fontFamily: "'questrial', sans-serif !important",
            display: "flex",
            flexDirection: { xs: "column", sm: "row", md: "row", lg: "row", xl: "row" },
            gap: { xs: 1, sm: 2, md: 3, lg: 3, xl: 3 },
            alignItems: "center",
            textAlign: { xs: "center", sm: "center", md: "left", lg: "left", xl: "left" },
          }}>
            <Link
              href="/about-us"
              underline="none"
              sx={{ 
                fontFamily: "'questrial', sans-serif !important",
                color: "black", 
                fontSize: { xs: "0.75rem", sm: "0.8rem", md: "0.8rem", lg: "0.8rem", xl: "0.8rem" },
                fontWeight: 400,
                "&:hover": { color: "#333", textDecoration: "underline" },
              }}
            >
              About Us
            </Link>
            <Link
              href="/faq"
              underline="none"
              sx={{ 
                fontFamily: "'questrial', sans-serif !important",
                color: "black", 
                fontSize: { xs: "0.75rem", sm: "0.8rem", md: "0.8rem", lg: "0.8rem", xl: "0.8rem" },
                fontWeight: 400,
                "&:hover": { color: "#333", textDecoration: "underline" },
              }}
            >
              FAQ
            </Link>
            <Link
              href="/privacy-policy"
              underline="none"
              sx={{ 
                fontFamily: "'questrial', sans-serif !important",
                color: "black", 
                fontSize: { xs: "0.75rem", sm: "0.8rem", md: "0.8rem", lg: "0.8rem", xl: "0.8rem" },
                fontWeight: 400,
                "&:hover": { color: "#333", textDecoration: "underline" },
              }}
            >
              Privacy Policy
            </Link>
            <Link
              href="/terms-conditions"
              underline="none"
              sx={{ 
                fontFamily: "'questrial', sans-serif !important",
                color: "black", 
                fontSize: { xs: "0.75rem", sm: "0.8rem", md: "0.8rem", lg: "0.8rem", xl: "0.8rem" },
                fontWeight: 400,
                "&:hover": { color: "#333", textDecoration: "underline" },
              }}
            >
              Terms & Conditions
            </Link>
            <Link
              href="/cookies-policy"
              underline="none"
              sx={{ 
                fontFamily: "'questrial', sans-serif !important",
                  color: "black", 
                fontSize: { xs: "0.75rem", sm: "0.8rem", md: "0.8rem", lg: "0.8rem", xl: "0.8rem" },
                fontWeight: 400,
                "&:hover": { color: "#333", textDecoration: "underline" },
              }}
            >
              Cookies Policy
            </Link>
          </Box>

          {/* Copyright */}
          <Typography
            variant="body2"
            sx={{ 
              fontFamily: "'questrial', sans-serif !important",
              fontSize: { xs: "0.75rem", sm: "0.8rem", md: "0.8rem", lg: "0.8rem", xl: "0.8rem" },
              color: "black",
              fontWeight: 400,
            }}
          >
            © 2025 by TECHT Labs
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
